export default __webpack_public_path__ + "static/media/aws-logo.72267181.png";